/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { ParameterName } from '../calculator/calculatorTypes';

export type Quantity =
  | 'quantity.volume'
  | 'quantity.dryingRate'
  | 'quantity.power'
  | 'quantity.relativeHumidity'
  | 'quantity.relativeSaturation'
  | 'quantity.temperature'
  | 'quantity.pressure'
  | 'quantity.gasConcentration'
  | 'quantity.liquidConcentration'
  | 'quantity.efficiency'
  | 'quantity.decompositionRate'
  | 'quantity.time'
  | 'quantity.liquidFlow'
  | 'quantity.airFlow'
  | 'quantity.carrierGasFlow';

const unitOptions: UnitOptions[] = [
  { quantity: 'quantity.volume', options: ['m3'] },
  { quantity: 'quantity.dryingRate', options: ['g/h', 'l/h', 'gr/h', 'oz/h'] },
  { quantity: 'quantity.power', options: ['kW'] },
  { quantity: 'quantity.relativeHumidity', options: ['%rh'] },
  { quantity: 'quantity.relativeSaturation', options: ['%rs'] },
  { quantity: 'quantity.temperature', options: ['°C', '°F'] },
  { quantity: 'quantity.pressure', options: ['hPa', 'inHg'] },
  { quantity: 'quantity.gasConcentration', options: ['ppm'] },
  { quantity: 'quantity.liquidConcentration', options: ['%-m'] },
  { quantity: 'quantity.efficiency', options: ['%'] },
  { quantity: 'quantity.decompositionRate', options: ['t1/2'] },
  { quantity: 'quantity.time', options: ['h:min:s'] },
  { quantity: 'quantity.liquidFlow', options: ['ml/min', 'oz/min'] },
  { quantity: 'quantity.airFlow', options: ['m3/min', 'm3/s', 'm3/h', 'ft3/min', 'ft3/s', 'ft3/h'] },
  { quantity: 'quantity.carrierGasFlow', options: ['l/min', 'm3/h', 'ft3/min', 'ft3/h'] },
];

const extractOptions: any = (q: string) => unitOptions.find((o: UnitOptions) => o.quantity === q)!.options;

const temperatureOps = extractOptions('quantity.temperature');
type TemperatureUnit = typeof temperatureOps[number];

const pressureOps = extractOptions('quantity.pressure');
type PressureUnit = typeof pressureOps[number];

export type Unit = TemperatureUnit | PressureUnit;

export type QuantityMapping = {
  parameter: ParameterName;
  quantity: Quantity;
};

type UnitSelection = {
  parameter: ParameterName;
  unitIndex: number;
};

export type UnitPreset = {
  mode: 'metric' | 'nonMetric' | 'manual';
  selections: UnitSelection[];
};

export type UnitOptions = {
  quantity: Quantity;
  options: Unit[];
};

export const optionsForQuantity = (q: Quantity) => unitOptions.find((o) => o.quantity === q);
